import type {GridData} from '@/components/DataTable/types';
import {
  getMarketSubmarketGrid,
  getMultifamilyMarketSubmarketGrid,
  getExitCapRateGrid,
} from './bigQueryGrids';
import {getOrenniaInterconnectionCostGrid} from './orenniaGrid';

type TableConfigHandler = (
  featureId: string,
  feature: Record<string, unknown>,
) => GridData | null;

export const tableConfigs: Record<string, TableConfigHandler> = {
  'Industrial Markets and Submarkets': getMarketSubmarketGrid,
  'Multifamily Markets and Submarkets': getMultifamilyMarketSubmarketGrid,
  'Exit Cap Rate': getExitCapRateGrid,
  'Orennia Buses': getOrenniaInterconnectionCostGrid,
};
